import { get } from 'lodash';
import { useEffect, useState } from 'react';
import GetRecord from 'src/lib/api/GetRecord';
import GetRecords from 'src/lib/api/GetRecords';
import POP_LEVEL from 'src/lib/api/Populations.json';
import { APIS } from 'src/lib/constants/apis';
import { UseFetchStatesType } from 'src/lib/types/types';
import { removeDataKeys, removeNullDeep } from 'src/utils/helper';

function useFetchFoerderProgramm(): UseFetchStatesType {
	const [loading, setLoading] = useState<boolean>(false);
	const [data, setData] = useState<any[]>([]);
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		// Fetch data
		const fetchData = async () => {
			try {
				const filter = { Allgemein_Aktiv: true };
				let sort = ['Allgemein_Titel_Deutsch:asc'];
				const res = await GetRecords(APIS.Foerderrichtlinie, POP_LEVEL.foerderrichtlinie.LIST_VIEW, filter, sort);
				const result: any[] = removeNullDeep(removeDataKeys(get(res, 'data', [])));
				setData(result);
			} catch (err: any) {
				setError(err.message);
			} finally {
				setLoading(false);
			}
		};

		fetchData();
	}, []);

	return { loading, data, error };
}

function useFetchFoerderProgrammDetail(id: number): UseFetchStatesType {
	const [loading, setLoading] = useState<boolean>(false);
	const [data, setData] = useState<any[]>([]);
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		// Fetch data
		const fetchData = async () => {
			try {
				const res = await GetRecord(APIS.Foerderrichtlinie, id, POP_LEVEL.foerderrichtlinie.DETAILS_SEITE);
				const result: any[] = removeNullDeep(removeDataKeys(get(res, 'data', [])));
				setData(result);
			} catch (err: any) {
				setError(err.message);
			} finally {
				setLoading(false);
			}
		};
		if (id) fetchData();
	}, [id]);

	return { loading, data, error };
}

export { useFetchFoerderProgramm, useFetchFoerderProgrammDetail };
